function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.28125 5C7.40557 5 7.5248 5.04939 7.61271 5.13729C7.70061 5.2252 7.75 5.34443 7.75 5.46875V5.9375H15.25V5.46875C15.25 5.34443 15.2994 5.2252 15.3873 5.13729C15.4752 5.04939 15.5944 5 15.7188 5C15.8431 5 15.9623 5.04939 16.0502 5.13729C16.1381 5.2252 16.1875 5.34443 16.1875 5.46875V5.9375H17.125C17.6223 5.9375 18.0992 6.13504 18.4508 6.48667C18.8025 6.83831 19 7.31522 19 7.8125V18.125C19 18.6223 18.8025 19.0992 18.4508 19.4508C18.0992 19.8025 17.6223 20 17.125 20H5.875C5.37772 20 4.90081 19.8025 4.54917 19.4508C4.19754 19.0992 4 18.6223 4 18.125V9.6875H19V8.75H4V7.8125C4 7.31522 4.19754 6.83831 4.54917 6.48667C4.90081 6.13504 5.37772 5.9375 5.875 5.9375H6.8125V5.46875C6.8125 5.34443 6.86189 5.2252 6.94979 5.13729C7.0377 5.04939 7.15693 5 7.28125 5Z",
  fill: "#747990"
});

function SvgCalendarFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilled);
export default __webpack_public_path__ + "static/media/calendar-filled.aab3f27298bb32dc39ab76bab6c19c51.svg";
export { ForwardRef as ReactComponent };